import { render } from "./BaseUpload.vue?vue&type=template&id=f71b2a2c&ts=true"
import script from "./BaseUpload.vue?vue&type=script&lang=ts"
export * from "./BaseUpload.vue?vue&type=script&lang=ts"

import "./BaseUpload.vue?vue&type=style&index=0&id=f71b2a2c&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__